import React from 'react';
import { Box, Paper, Typography, Button, Stack, Divider, Avatar } from '@mui/material';
import { Add } from '@mui/icons-material';
import { sxConfig } from './workspace.style';

const HistoryCard = ({ handleNewCrmTask }) => {
  return (
    <Paper sx={{ ...sxConfig.card, p: 3 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        mb={3}
      >
        <Typography variant="h6" fontWeight={700}>
          Előzmények
        </Typography>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Button variant="contained" startIcon={<Add />} onClick={handleNewCrmTask}>
            Új esemény
          </Button>
        </Stack>
      </Stack>
      {/*<Box mb={3}>
        <Typography color="text.secondary" mb={1}>
          2026. június 26. péntek
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Stack direction="row" spacing={2} alignItems="flex-start">
          <Avatar sx={{ bgcolor: 'primary.main' }}>K</Avatar>
          <Box flex={1}>
            <Typography fontWeight={700}>Sikeres teendő - Török Bence</Typography>
            <Typography mt={1} fontWeight={700}>
              Újabb teendő
            </Typography>
            <Button size="small" variant="outlined" sx={{ mt: 2 }}>
              Megtekint
            </Button>
          </Box>
          <Typography color="text.secondary">14:59</Typography>
        </Stack>
      </Box>*/}
    </Paper>
  );
};

export default HistoryCard;
